import React from 'react';
import * as S from './LogsList.styled';
import { useSelector } from 'react-redux';
import Table from './components/Table';
import { LogsListItemsSelector, removeLog } from './LogsListSlice';
import { IsOwnerSelector } from 'features/User/UserSlice';
import { useAppDispatch } from 'hooks/useStore';

const LogsList: React.FC = () => {
  const dispatch = useAppDispatch();
  // Список логов
  const logs = useSelector(LogsListItemsSelector);
  const isOwner = useSelector(IsOwnerSelector);

  // Удаление лога
  const onRemove = (id: number) => dispatch(removeLog(id));

  return (
    <S.Wrap>
      <Table items={logs} isOwner={isOwner} onRemove={onRemove} />
    </S.Wrap>
  );
};

export default LogsList;
